import { useState } from "react";
import { Form } from "react-bootstrap";

const ChatIssueReason = ({
  reason,
  feedbackReasons,
  setFeedbackReasons,
  message
}) => {

  const [rstate, setRstate] = useState(reason);

  const handleChange = (e, r) => {
    //console.log("hanlde ChatIssueReason", e.target.checked, feedbackReasons);
    // add reason
    if (e.target.checked === true) {
      setRstate({
        ...reason,
        checked: true
      })
      setFeedbackReasons([...feedbackReasons, reason.reasonId]);
    } else {
      setRstate({
        ...reason,
        checked: false
      })
      let rs = [...feedbackReasons];
      rs = rs.filter(item => item != r.reasonId);
      setFeedbackReasons(rs);
    }
  }

  return (
    <>
      <Form.Check
        type={"checkbox"}
        id={reason.reasonId}
      >
        <Form.Check.Input
          className="mt-2"
          type={"checkbox"}
          onChange={(e) => handleChange(e, reason)}
          checked={rstate?.checked || reason?.checked}
          //checked={reason?.checked}
          disabled={message?.isChatIssueSubmit === true}
        />
        <Form.Check.Label
          className={rstate?.checked || reason?.checked ? "reason-label-active" : ""}
        >
          {reason.reasonText}
        </Form.Check.Label>
      </Form.Check>
    </>
  )
}

export default ChatIssueReason;